import React from "react"
import { GREY } from "../styles/constants"

export const GreyDot: React.FC = () => {
    return <div style={{
        backgroundColor: GREY,
        width: '10px',
        height: '10px',
        borderRadius: '50%'
    }} />
} 